import React, { useState, useEffect } from "react";
import { Sparkles, ChevronLeft, ChevronRight, X } from "lucide-react";
import { fetchActivePromotion } from "../services/dashboardService";
import "./PromoDrawer.css";

const PromoDrawer = () => {
  const [promo, setPromo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Collapsed state
  const [isExpanded, setIsExpanded] = useState(() => {
    try {
      const saved = localStorage.getItem("yooki_promo_expanded");
      return saved !== null ? JSON.parse(saved) : true;
    } catch {
      return true;
    }
  });

  useEffect(() => {
    let isMounted = true;
    const loadPromotion = async () => {
      try {
        const res = await fetchActivePromotion();
        if (isMounted && res && res.success && res.promotion) {
          if (!res.promotion.theme || res.promotion.theme.startsWith("promo")) {
            setPromo(res.promotion);
          }
        }
      } catch (err) {
        console.warn("Could not load promotional banner:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadPromotion();
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading || !promo || !promo.image_url) {
    return null;
  }

  const toggleExpand = () => {
    const nextState = !isExpanded;
    setIsExpanded(nextState);
    try {
      localStorage.setItem("yooki_promo_expanded", JSON.stringify(nextState));
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageClick = () => {
    if (promo.target_url) {
      window.open(promo.target_url, "_blank", "noopener,noreferrer");
    }
  };

  const tabText = promo.tab_text || "OFFER";

  return (
    <div
      className={`promo-drawer-wrapper ${isExpanded ? "expanded" : "collapsed"}`}
      aria-label="Promotional Announcement"
    >
      {/* 36px Vertical Interactive Edge Tab */}
      <button
        type="button"
        className="promo-edge-tab"
        onClick={toggleExpand}
        title={isExpanded ? "Collapse announcement" : `Click to view ${promo.title || "offer"}`}
        aria-expanded={isExpanded}
      >
        <span className="promo-tab-icon-wrap">
          {isExpanded ? (
            <ChevronRight size={14} className="promo-tab-arrow" />
          ) : (
            <ChevronLeft size={14} className="promo-tab-arrow" />
          )}
          <Sparkles size={13} className="promo-tab-sparkle" />
        </span>
        <span className="promo-tab-text">{tabText}</span>
      </button>

      {/* Main Promo Banner Card Body */}
      <div className="promo-banner-card db-promo-card">
        {/* Close Button */}
        <button
          type="button"
          className="promo-close-btn"
          onClick={toggleExpand}
          aria-label="Close banner"
          title="Minimize to side tab"
        >
          <X size={15} />
        </button>

        {/* Clickable Banner Image */}
        <div
          className="promo-image-container"
          onClick={handleImageClick}
          title={promo.title || "Click to view offer"}
        >
          <img
            src={promo.image_url}
            alt={promo.title || "Promotional Banner"}
            className="promo-banner-image"
          />
        </div>
      </div>
    </div>
  );
};

export default PromoDrawer;

